import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSInlineImageTagName: string = 'hhds-inline-image';
const TAG_NAME: string = HHDSInlineImageTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSInlineImageAttrNames = {};

//const Attrs = HHDSInlineImageAttrNames;

export class HHDSInlineImage extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = /* html */ `
      <div class="${TAG_NAME}">
				<slot></slot>
			</div>
    `;

		this.setInnerHtml('', '', html);

		this.observeSlotChanges(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
